import { useQueryClient } from "@tanstack/react-query";
import { useContext, useState } from "react";
import useGetOrg from "src/hooks/useGetOrganization";
import useLocales from "src/hooks/useLocales";
import { useCreateOrgUserRequest } from "src/services/organizations/commands/users";
import SnackbarUtils from "src/utils/SnackbarUtils";

import Context from "../context";

export const useCreateOrgUser = () => {
	const { actions } = useContext(Context);
	const [isLoading, setIsLoading] = useState(false);

	const { id } = useGetOrg();
	const { mutate } = useCreateOrgUserRequest();
	const queryClient = useQueryClient();
	const { translate } = useLocales();

	const onSuccess = () => {
		setIsLoading(false);
		SnackbarUtils.success(translate("organization.invited_user_success"));
		actions.onClose();
		queryClient.invalidateQueries({
			queryKey: ["organization", "users"]
		});
	};

	const onError = () => {
		setIsLoading(false);
		SnackbarUtils.error(translate("organization.invited_user_error"));
	};

	const onCreateUser = (email: string, role: string) => {
		setIsLoading(true);
		mutate(
			{ orgId: id, email, role },
			{
				onSuccess,
				onError
			}
		);
	};

	return { onCreateUser, isLoading };
};
